export default __webpack_public_path__ + "media/images/features/hida/hero-bg-214860c388889dcc526f8d370c0bec44.png";